'use client';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { useTranslations } from 'next-intl';
import { FC, useEffect, useState } from 'react';

import {
  linkItem,
  linkItemAnchor,
  linkItems,
  title,
  wrapper,
} from './index.css';

/**
 * Props for `Summary`.
 */
export type SummaryProps = SliceComponentProps<Content.SummarySlice>;

/**
 * Component for "Summary" Slices.
 */
const Summary: FC<SummaryProps> = ({ slice }) => {
  const [titles, setTitles] = useState<HTMLHeadingElement[]>([]);
  const t = useTranslations();

  useEffect(() => {
    if (document) {
      setTitles(
        // `Element.checkVisibility()` is unsupported on Safari < 17.4 (and other
        // older browsers); calling it there throws and crashes the page. Feature-
        // detect and fall back to an offsetParent check (null when the element or
        // an ancestor is `display:none`).
        Array.from(document.querySelectorAll('h2')).filter((elem) =>
          typeof elem.checkVisibility === 'function'
            ? elem.checkVisibility()
            : elem.offsetParent !== null,
        ),
      );
    }
  }, []);

  if (titles.length === 0) {
    return null;
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={wrapper}
    >
      <span className={title}>{t('pages.guides.summary.title')}</span>
      <ul className={linkItems}>
        {titles.map((title) => (
          <li className={linkItem} key={title.id}>
            <a className={linkItemAnchor} href={`#${title.id}`}>
              {title.innerText}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Summary;
